import script from "./MaterialComponentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialComponentItem.vue?vue&type=script&setup=true&lang=js"

import "./MaterialComponentItem.vue?vue&type=style&index=0&id=2ae5862e&lang=css"

const __exports__ = script;

export default __exports__